(function() {
  if (customElements.get('header-menu-megamenu')) return;

  class HeaderMenuMegamenu extends HTMLElement {
    constructor() {
      super();

      /** @type {HTMLElement[]} */
      this.megamenuItems = [];
      this.onMenuItemClick = this.onMenuItemClick.bind(this);
      this.onMenuItemMouseEnter = this.onMenuItemMouseEnter.bind(this);
      this.onMenuItemMouseLeave = this.onMenuItemMouseLeave.bind(this);
      this.onPanelMouseEnter = this.onPanelMouseEnter.bind(this);
      this.onPanelMouseLeave = this.onPanelMouseLeave.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.hoverTimeout = null;
      this.openTimeout = null;
      this.openDelay = 500; 
      this.closeDelay = 400; 
    }

    connectedCallback() {
      this.megamenuItems = Array.from(this.querySelectorAll('.js-megamenu-parent'));
      this.trigger = this.dataset.trigger || 'hover';
      this.setEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
      }
      if (this.openTimeout) {
        clearTimeout(this.openTimeout);
      }
    }

    setEventListeners() {
      if (this.trigger === 'click') {
        // Click mode
        this.megamenuItems.forEach(item => {
          const link = item.querySelector('.js-megamenu-trigger');
          if (link) {
            link.addEventListener('click', this.onMenuItemClick);
          }
        });
        document.addEventListener('click', this.onDocumentClick);
      } else {
        // Hover mode
        this.megamenuItems.forEach(item => {
          item.addEventListener('mouseenter', this.onMenuItemMouseEnter);
          item.addEventListener('mouseleave', this.onMenuItemMouseLeave);
          
          const panel = item.querySelector('.header-menu-megamenu__panel');
          if (panel) {
            panel.addEventListener('mouseenter', this.onPanelMouseEnter);
            panel.addEventListener('mouseleave', this.onPanelMouseLeave);
          }
        });
      }
    }

    removeEventListeners() {
      this.megamenuItems.forEach(item => {
        const link = item.querySelector('.js-megamenu-trigger');
        if (link) {
          link.removeEventListener('click', this.onMenuItemClick);
        }
        item.removeEventListener('mouseenter', this.onMenuItemMouseEnter);
        item.removeEventListener('mouseleave', this.onMenuItemMouseLeave);
        
        const panel = item.querySelector('.header-menu-megamenu__panel');
        if (panel) {
          panel.removeEventListener('mouseenter', this.onPanelMouseEnter);
          panel.removeEventListener('mouseleave', this.onPanelMouseLeave);
        }
      });
      document.removeEventListener('click', this.onDocumentClick);
    }

    /**
     * @param {MouseEvent} event
     */
    onMenuItemMouseEnter(event) {
      if (this.trigger !== 'hover') return;
      
      const parent = event.currentTarget;
      if (!(parent instanceof HTMLElement)) return;

      // Скасовуємо попередні таймери
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
      if (this.openTimeout) {
        clearTimeout(this.openTimeout);
        this.openTimeout = null;
      }

      // Додаємо затримку перед відкриттям
      this.openTimeout = setTimeout(() => {
        // Close all other panels
        this.megamenuItems.forEach(item => {
          if (item !== parent) {
            item.classList.remove('active');
          }
        });

        // Open current panel
        const hasPanel = parent.querySelector('.header-menu-megamenu__panel');
        if (hasPanel) {
          parent.classList.add('active');
          this.positionPanel(parent, hasPanel);
        }
      }, this.openDelay);
    }

    /**
     * @param {MouseEvent} event
     */
    onMenuItemMouseLeave(event) {
      if (this.trigger !== 'hover') return;
      
      const parent = event.currentTarget;
      if (!(parent instanceof HTMLElement)) return;

      if (this.openTimeout) {
        clearTimeout(this.openTimeout);
        this.openTimeout = null;
      }

      this.hoverTimeout = setTimeout(() => {
        parent.classList.remove('active');
      }, this.closeDelay);
    }

    /**
     * @param {MouseEvent} event
     */
    onPanelMouseEnter(event) {
      if (this.trigger !== 'hover') return;
      
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }

      if (this.openTimeout) {
        clearTimeout(this.openTimeout);
        this.openTimeout = null;
      }
    }

    /**
     * @param {MouseEvent} event
     */
    onPanelMouseLeave(event) {
      if (this.trigger !== 'hover') return;
      
      const panel = event.currentTarget;
      if (!(panel instanceof HTMLElement)) return;
      
      const parent = panel.closest('.js-megamenu-parent');
      if (!parent) return;

      if (this.openTimeout) {
        clearTimeout(this.openTimeout);
        this.openTimeout = null;
      }

      this.hoverTimeout = setTimeout(() => {
        parent.classList.remove('active');
      }, this.closeDelay);
    }

    /**
     * @param {MouseEvent} event
     */
    onMenuItemClick(event) {
      if (this.trigger !== 'click') return;
      
      const link = event.currentTarget;
      if (!(link instanceof HTMLElement)) return;

      const parent = link.closest('.js-megamenu-parent');
      if (!parent) return;

      // Check if this menu item has a megamenu panel
      const hasPanel = parent.querySelector('.header-menu-megamenu__panel');
      
      // Only prevent default if there's a megamenu panel to show
      if (!hasPanel) return;
      
      event.preventDefault();

      const isActive = parent.classList.contains('active');

      // Close all other panels
      this.megamenuItems.forEach(item => {
        if (item !== parent) {
          item.classList.remove('active');
        }
      });

      // Toggle current panel
      parent.classList.toggle('active', !isActive);
      if (!isActive && hasPanel) {
        this.positionPanel(parent, hasPanel);
      }
    }

    /**
     * Position the dropdown panel centered under its parent menu item,
     * clamped so it never overflows the viewport edges.
     * @param {HTMLElement} parent - The .js-megamenu-parent li element
     * @param {HTMLElement} panel - The .header-menu-megamenu__panel element
     */
    positionPanel(parent, panel) {
      const link = parent.querySelector('.header-menu-megamenu__link');
      if (!link) { panel.style.left = '0'; return; }

      const linkRect = link.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();
      const panelWidth = panel.offsetWidth || panel.scrollWidth;
      const viewportWidth = document.documentElement.clientWidth;
      const pad = 16; // minimum distance from viewport edge

      // Center panel under the link
      const linkCenter = linkRect.left + linkRect.width / 2;
      let idealLeft = linkCenter - panelWidth / 2;

      // Clamp to viewport
      if (idealLeft < pad) idealLeft = pad;
      if (idealLeft + panelWidth > viewportWidth - pad) {
        idealLeft = viewportWidth - pad - panelWidth;
      }

      // Convert to offset relative to parent li
      const offsetLeft = idealLeft - parentRect.left;
      panel.style.left = Math.round(offsetLeft) + 'px';
    }

    /**
     * @param {MouseEvent} event
     */
    onDocumentClick(event) {
      if (this.trigger !== 'click') return;
      
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (!target.closest('header-menu-megamenu')) {
        this.megamenuItems.forEach(item => {
          item.classList.remove('active');
        });
      }
    }
  }

  customElements.define('header-menu-megamenu', HeaderMenuMegamenu);
})();


/* Force-load lazy images when megamenu panel opens */
(function() {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type === "attributes" && m.attributeName === "class") {
        var el = m.target;
        if (el.classList.contains("active") && el.classList.contains("js-megamenu-parent")) {
          var imgs = el.querySelectorAll("img[loading=lazy]");
          imgs.forEach(function(img) { img.loading = "eager"; });
        }
      }
    });
  });
  document.querySelectorAll(".js-megamenu-parent").forEach(function(el) {
    observer.observe(el, { attributes: true, attributeFilter: ["class"] });
  });
  /* force-load-megamenu-images */
})();
